import { css } from '@emotion/react'
import styled from '@emotion/styled'

const buttonStyles = ({ theme }) => css`
  label: button-wrapper;

  margin-top: ${theme.spacings.giga};
`
export const ButtonWrapper = styled('div')(buttonStyles)
